export const EXAMPLE_URL_PLACEHOLDER = 'https://example.com'

export const INITIAL_PAGE = '/dashboard'
export const LEAD_URI = 'lead'
export const LEAD_ROUTE = `${LEAD_URI}/`
export const LEAD_ROUTE_V2 = `${LEAD_URI}/v2/`
